"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_range_1 = require("react-range");
const classnames_1 = __importDefault(require("classnames"));
const helpers_1 = require("../../lib/helpers");
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const Input_1 = __importDefault(require("./Base/Input"));
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const useInputForm_1 = require("../../hooks/useInputForm");
const RangeInput = (props) => {
    var _a;
    const { step = 1, showMarkLabel, onChange, name, marks } = props;
    let { min, max } = props;
    let markRecords = [];
    if (Array.isArray(marks)) {
        // provided [1,2,3,4,5]
        if (typeof marks[0] !== 'object') {
            marks.forEach((mark) => {
                markRecords.push({
                    label: mark,
                    value: mark,
                });
            });
        }
        else {
            // provided mark recrords
            markRecords = marks;
        }
    }
    else if (typeof marks === 'object') {
        Object.keys(marks).forEach((markName) => {
            markRecords.push({
                label: markName,
                value: marks[markName],
            });
        });
    }
    else if (min !== undefined && max !== undefined) {
        // create an array based off the steps with a max.
        const steps = helpers_1.newArray(((max + step) - min) / (step !== null && step !== void 0 ? step : 1))
            .map((k) => (min + (k * step)));
        // map 5 into 5: '5', 10 into 10: '10'
        steps.forEach((step) => {
            markRecords.push({ label: `${step}`, value: step });
        });
    }
    min = 0;
    max = markRecords.length > 0 ? markRecords.length - 1 : 0;
    let value = useInputForm_1.useInputValue(props);
    value = Number.parseInt(`${value !== null && value !== void 0 ? value : 0}`, 10);
    const inputRef = react_1.useRef(null);
    const onRangeCompChange = (newMarkRecordKeys) => {
        const newMarkRecordKey = newMarkRecordKeys[0];
        helpers_1.createSimulatedEvent(inputRef.current, `${markRecords[newMarkRecordKey].value}`);
    };
    let markRecordKey = markRecords.findIndex((r) => r.value === value);
    if (markRecordKey === -1) {
        markRecordKey = 0;
    }
    const values = [markRecordKey];
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name, error: props.error },
        react_1.default.createElement(Input_1.default, Object.assign({}, helpers_1.without(props, ['className']), { name: (_a = name) !== null && _a !== void 0 ? _a : '', value: value, onChange: onChange, ref: inputRef })),
        react_1.default.createElement(InputLabel_1.default, null),
        react_1.default.createElement("div", { className: "j-range-width-panel", style: { minWidth: markRecords.length * 30 } },
            react_1.default.createElement(react_range_1.Range, { renderTrack: ({ props, children }) => {
                    const bg = react_range_1.getTrackBackground({
                        values,
                        colors: ['rgb(var(--primary))', 'rgba(var(--primary), .4)'],
                        min: min !== null && min !== void 0 ? min : 0,
                        max: max !== null && max !== void 0 ? max : 0,
                    });
                    return react_1.default.createElement("div", Object.assign({}, props, { className: "j-range-input-track", style: Object.assign(Object.assign({}, props.style), { background: bg }) }), children);
                }, renderThumb: ({ props }) => (react_1.default.createElement("div", Object.assign({}, props, { className: "j-range-input-thumb" }))), renderMark: ({ props }) => {
                    var _a;
                    const isStart = props.key === 'mark0';
                    const isEnd = props.key === `mark${markRecords.length - 1}`;
                    let left = isStart ? 0 : props.style.left;
                    const right = isEnd ? 0 : undefined;
                    if (isEnd) {
                        left = undefined;
                    }
                    const propKeyNumber = Number.parseInt(props.key.replace('mark', ''), 10);
                    const isOutside = markRecordKey < propKeyNumber;
                    return (react_1.default.createElement("div", Object.assign({}, props, { className: classnames_1.default('j-range-input-mark-wrap', { end: isEnd, start: isStart, outside: isOutside }), style: Object.assign(Object.assign({}, props.style), { marginTop: -5, left, right }) }),
                        react_1.default.createElement("div", { className: "j-range-input-mark" }),
                        showMarkLabel && (react_1.default.createElement("div", { className: "j-range-input-mark-label" }, showMarkLabel && ((_a = markRecords[Number.parseInt(props.key.replace('mark', ''), 10)]) === null || _a === void 0 ? void 0 : _a.label)))));
                }, values: values, onChange: onRangeCompChange, step: 1, min: min, max: max })),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-range-input', RangeInput);
